/*
  Zufalls-Auswahl der Experten-Cards (Homepage). Der Server rendert den ganzen Pool;
  hier werden bei jedem Aufruf N Cards zufällig sichtbar gemacht (Fisher-Yates), der Rest
  versteckt. Ohne JS bleiben die serverseitig sichtbaren ersten N stehen (graceful).
*/
(function () {
  function shuffleVisible(grid) {
    var n = parseInt(grid.dataset.visible || '3', 10);
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.momo-experts__card'));
    if (cards.length <= n) return;

    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = cards[i];
      cards[i] = cards[j];
      cards[j] = tmp;
    }

    cards.forEach(function (card, index) {
      if (index < n) {
        card.hidden = false;
        grid.appendChild(card); // sichtbare nach vorn, in zufälliger Reihenfolge
      } else {
        card.hidden = true;
      }
    });
  }

  function init() {
    document.querySelectorAll('.momo-experts__grid--random').forEach(shuffleVisible);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
